module.exports = __webpack_public_path__ + "img/card-btn-2.dc9a0fd3.png";